import React from 'react';
import { useRootStore } from 'store';
import { useTranslation } from 'react-i18next';
import { Col } from 'react-bootstrap';
import {
  ButtonApprove,
  FieldCheckBox,
  FieldInput,
  FieldTextArea,
  FormCol,
  FormCol2,
  useIsFieldRequiredHook,
} from 'motion-components';
import { useFormikContext } from 'formik';
import { useHandleError } from 'shared-pages/services';
import { dateField, isActiveField } from 'shared-pages/common/form-helpfunc';
import { FileRepoField } from 'shared-pages/components/filerepo-field';
import { FieldSelectCollector, FieldSelectVehicle } from 'shared-pages/components';
import { isFotokiklosi, isRebattery, isRebatteryLiion } from 'shared-pages/common/constants';

export const FormFields = ({
  isNew,
  updateRecord,
  refetch,
  data,
  handleApprove,
  validationSchema = undefined,
}) => {
  const { values, setFieldValue, errors, isValid, touched } = useFormikContext<any>();
  const isFieldRequired = useIsFieldRequiredHook(validationSchema);

  const { authStore, appStore } = useRootStore();
  const { handleGraphqlError } = useHandleError('PiBaseFormFields');
  const { t } = useTranslation();

  function calcUserCanEdit() {
    let canEdit = appStore.isPlatformOwner || appStore.isCollector || isNew;
    if (isRebattery || isRebatteryLiion) {
      canEdit = appStore.isPlatformOwner || isNew;
    } else if (isFotokiklosi) {
      canEdit = appStore.isPlatformOwner || isNew;
    }
    const canEditReasoning = '';
    return { canEdit, canEditReasoning };
  }
  const { canEdit, canEditReasoning } = calcUserCanEdit();

  function calcUserCanEditADR() {
    let canEditADR = appStore.isPlatformOwner || appStore.isCollector;
    if (isFotokiklosi) {
      canEditADR = canEdit;
    }
    const canEditADRReasoning = '';
    return { canEditADR, canEditADRReasoning };
  }
  const { canEditADR, canEditADRReasoning } = calcUserCanEditADR();

  return (
    <>
      <div className="d-flex flex-row">
        {/* 1η Στήλη */}
        <FormCol>
          <FieldInput
            label={t('Ονοματεπώνυμο Οδηγού')}
            name="name"
            placeholder=""
            disabled={!canEdit}
            required={isFieldRequired('name', values)}
          />
          <FieldSelectCollector
            disabled={!canEdit}
            label={t('Συλλέκτης')}
            name="collectorId"
            required={isFieldRequired('collectorId', values)}
          />
          {!isRebattery && (
            <FieldInput label={t('Τηλέφωνο')} name="phone" placeholder="" disabled={!canEdit} />
          )}

          <FieldTextArea
            disabled={!canEdit}
            label={t('Σχόλια')}
            name="notes"
            type="text"
            rows={5}
            placeholder={t('')}
            required={false}
          />
        </FormCol>

        {/* 2η Στήλη */}
        <FormCol>
          <FieldInput
            label={t('Αριθμός ADR')}
            name="adrNumber"
            placeholder=""
            disabled={!canEditADR}
            required={isFieldRequired('adrNumber', values)}
          />

          {/* {dateField(t('Λήξη Άδειας'), 'licenseExpDate', t, canEdit)} */}
          {/* <FormRow className="mb-2 pb-2" style={{ minHeight: '41.16px' }}></FormRow> */}
          {dateField(
            t('Λήξη ADR'),
            'adrExpDate',
            t,
            canEditADR,
            undefined,
            isFieldRequired('adrExpDate', values),
          )}
          <FileRepoField
            as={Col}
            label={t('Ανάρτηση Διπλώματος ADR')}
            fileIdFieldName="adrFileId"
            fileRec={data?.adrFilesrepository}
            canEdit={canEditADR}
          />
          <FileRepoField
            as={Col}
            label={t('Αρχείο Υπογραφής Οδηγού')}
            fileIdFieldName="signFileId"
            fileRec={data?.signFilesrepository}
            canEdit={canEdit}
          />
          {/* <FileRepoField
            as={Col}
            label={t('Αρχείο Άδειας')}
            fileIdFieldName="licenseFileId"
            fileRec={data?.licenseFileRec}
            canEdit={canEdit}
          /> */}
          {!isRebattery && <FieldSelectVehicle disabled={!canEdit} />}
        </FormCol>

        {/* 3η Στήλη */}
        <FormCol>
          {isActiveField(t, canEdit)}
          {appStore.isPlatformOwner && (
            <>
              <FieldCheckBox
                disabled={true}
                as={'div'}
                label={t('Εγκεκριμένος Οδηγός')}
                name="isApproved"
                onLabel={t('ΝΑΙ')}
                offLabel={t('ΟΧΙ')}
              />
              <FieldInput label={t('Έγκριθηκε από')} name="approvedBy" disabled={true} />
              {dateField(t('Ημ/νία Έγκρισης'), 'approvedDate', t, false)}

              {data?.isApproved === false && (
                <ButtonApprove
                  onClick={() => handleApprove()}
                  text={t('Έγκριση Διπλώματος ADR')}
                  className="col-12"
                />
              )}
            </>
          )}
        </FormCol>
      </div>
    </>
  );
};
